<template>
		<chatbot-inline
			:alerts="alerts"
			:translations="translations"
			:code="code"
			:prevent-unload="preventUnload"
			:show-chatbot="true"
			:title="title"
			:market="market"
			@close="closeChat"
		/>
</template>

<script>
	import Message from "./chatbotInstructions/Message";
	import Call from "./chatbotInstructions/Call";
	import Select from "./chatbotInstructions/Select";
	import SelectOption from "./chatbotInstructions/SelectOption";
	import Form from "./chatbotInstructions/Form";
	import FormField from "./chatbotInstructions/FormField";
	import Custom from "./chatbotInstructions/Custom";
	import Restart from "./chatbotInstructions/Restart";
	import Flashes from "./chatbotInstructions/Flashes";

	export default {
		props: {
			translations: {
				type: Object,
				required: true,
			},
			urls: {
				type: Object,
				required: true,
			},
			alerts: {
				type: Object,
				required: true,
			},
			title: {
				type: String,
				default: ''
			},
			product: {
				type: String,
				default: 'emv'
			},
			order: {
				type: Object,
				required: true,
			},
			market: {
				type: String,
				default: 'monizze'
			}
		},
		data ()
		{
			const trans = this.translations.fileImport;
			const self = this;

			return {
				preventUnload: false,
				code: {
					/*
					 * Entry point
					 */
					main: [
						new Call('check'),
					],
					check: [
						new Message(trans.check.intro),
						new Message(trans.check.time),
						new Custom(
							async function(variables)
							{
								let donePooling = false;
								variables.warnings = null;

								while(!donePooling)
								{
									await new ApiMonizze()
										.getDataFromApi(
											self.urls.stats.replace('{reference}', self.order.reference),
											function(data)
											{
												if( data === null )
												{
													return;
												}

												variables.number = data.exists;
												variables.names = data.new.join(', ');

												variables.tempBenefsCheck = data.temporary_benef_check;
												variables.sameNameBenef = data.same_name_benef_check;
												variables.eco_gift_warning = data.eco_gift_warning;
												variables.currentFlow = '';

												if(data.warnings && data.warnings.length > 0)
												{
													variables.warnings = data.warnings.map(htmlEncode).join('<br />');
												}
												donePooling = true;
											}
										);

									if( !donePooling )
									{
										// We wait 1sec between retry
										await new Promise(resolve => setTimeout(resolve, 1000));
									}
								}
							}
						),
						new Call('summary'),
					],
					error: [
						new Flashes((variables) => variables.errors),
					  	new Message((variables) => variables.warnings, true).if((variables) => variables.warnings && variables.warnings.length > 0),
						new Message(trans.error.intro),
						new Select(
							'nextCall',
							Object.entries(trans.error.options)
								.map(([key, value]) => new SelectOption(key, value.label))
						),
						new Message((variables) => trans.error.options[variables.nextCall].response).isFromUser(),
						new Custom(
							function()
							{
								self.$emit('cancel', self.order.reference);
							}
						).if((variables) => variables.nextCall === 'upload'),
						new Call((variables) => variables.nextCall).if((variables) => variables.nextCall !== 'upload'),
					],
					//Check if the imported users have the same name as the existing users of the requesting customer
					check_same_name: [
						new Call(
							function(variables)
							{
								if (variables.sameNameBenef.length > 0)
								{
									self.mergeitem = variables.sameNameBenef.shift();

									variables.newUserNiss = self.mergeitem.new.niss;
									variables.newUserName = self.mergeitem.new.full_name;
								}
								variables.currentFlow = 'check_same_name';
							}
						),
						new Message(trans.user_with_same_name.intro),
						new Select(
							'confirm_action',
							Object.entries(trans.user_with_same_name.options)
								.filter(option => option[0] === 'deny')
								.map(([key, value]) => new SelectOption(key, value.label)),
							function (translations, variables)
							{
								let customTranslations = [];
								self.mergeitem.old.forEach(function (oldUser) {
									variables['oldUserId_' + oldUser.user_id] = oldUser.user_id;
									variables['oldUserNiss_' + oldUser.user_id] = oldUser.niss;
									variables['oldUserName_' + oldUser.user_id] = oldUser.full_name;
									let tr = { ...trans.user_with_same_name.options.keep_old_user };
									tr.label = tr.label.replace('oldUserName', 'oldUserName_' + oldUser.user_id).replace('oldUserNiss', 'oldUserNiss_' + oldUser.user_id)
									tr.response = tr.response.replace('oldUserName', 'oldUserName_' + oldUser.user_id).replace('oldUserNiss', 'oldUserNiss_' + oldUser.user_id)
									customTranslations.push(new SelectOption('keep_old_user|' + oldUser.user_id, tr.label));
									tr = { ...trans.user_with_same_name.options.keep_imported_user };
									tr.label = tr.label.replace('oldUserName', 'oldUserName_' + oldUser.user_id).replace('oldUserNiss', 'oldUserNiss_' + oldUser.user_id)
									tr.response = tr.response.replace('oldUserName', 'oldUserName_' + oldUser.user_id).replace('oldUserNiss', 'oldUserNiss_' + oldUser.user_id)
									customTranslations.push(new SelectOption('keep_imported_user|' + oldUser.user_id, tr.label));
								});
								return [
									...customTranslations,
									new SelectOption('deny', translations[0].label),
								];
							}
						),
						new Message((variables) => {
							let confirm_action = variables.confirm_action.split('|');

							if (confirm_action.length > 1)
							{
								variables.oldUserId = variables['oldUserId_' + confirm_action[1]] ;
								variables.oldUserNiss = variables['oldUserNiss_' + confirm_action[1]] ;
								variables.oldUserName = variables['oldUserName_' + confirm_action[1]] ;
							}

							return trans.user_with_same_name.options[confirm_action[0]].response
						}).isFromUser(false),
						new Call('deny_same_name_merge').if((variables) => variables.confirm_action === 'deny'),
						new Call('keep_imported_user').if((variables) => variables.confirm_action.startsWith('keep_imported_user')),
						new Call('keep_old_user').if((variables) => variables.confirm_action.startsWith('keep_old_user')),
						new Call('check_same_name').if((variables) => variables.sameNameBenef.length > 0),
						new Call('summary_same_name').if((variables) => variables.sameNameBenef.length === 0),
					],
					keep_imported_user: [
						new Call(
							function(variables)
							{
								variables.names = variables.names.length > 0
									? variables.names + ', ' + variables.newUserName
									: variables.newUserName;
								variables.currentFlow = 'keep_imported_user';
							}
						),
						new Custom(
							async function(variables)
							{
								let donePooling = false;
								variables.warnings = null;

								let postData = {
									'user_id' : variables.confirm_action.split('|')[1],
									'action': 'replace-existing',
								};

								while(!donePooling)
								{
									await new ApiMonizze()
										.postDataFromApi(
											self.urls.solve_same_name_users.replace('{reference}', self.order.reference),
											postData,
											function(data)
											{
												if( data === null )
												{
													return;
												}

												variables.number = data.exists;

												if(data.warnings && data.warnings.length > 0)
												{
													variables.warnings = data.warnings.map(htmlEncode).join('<br />');
												}

												donePooling = true;
											}
										);

									if( !donePooling )
									{
										// We wait 1sec between retry
										await new Promise(resolve => setTimeout(resolve, 1000));
									}
								}
							}
						),
						new Message(trans.user_with_same_name.keep_imported_user_message),
						new Call('error').if((variables) => variables.warnings && variables.warnings.length > 0),
					],
					keep_old_user: [
						new Call(
							function(variables)
							{
								variables.names = variables.names.length > 0
									? variables.names + ', ' + variables.newUserName
									: variables.newUserName;
								variables.currentFlow = 'keep_old_user';
							}
						),
						new Custom(
							async function(variables)
							{
								let donePooling = false;
								variables.warnings = null;

								let postData = {
									'user_id' : variables.confirm_action.split('|')[1],
									'action': 'replace-imported',
								};

								while(!donePooling)
								{
									await new ApiMonizze()
										.postDataFromApi(
											self.urls.solve_same_name_users.replace('{reference}', self.order.reference),
											postData,
											function(data)
											{
												if( data === null )
												{
													return;
												}

												variables.number = data.exists;

												if(data.warnings && data.warnings.length > 0)
												{
													variables.warnings = data.warnings.map(htmlEncode).join('<br />');
												}

												donePooling = true;
											}
										);

									if( !donePooling )
									{
										await new Promise(resolve => setTimeout(resolve, 1000));
									}
								}
							}
						),
						new Message(trans.user_with_same_name.keep_old_user_message),
						new Call('error').if((variables) => variables.warnings),
					],
					deny_same_name_merge: [
						new Call(
							function(variables)
							{
								variables.names = variables.names.length > 0
									? variables.names + ', ' + variables.newUserName
									: variables.newUserName;
								variables.currentFlow = 'deny_same_name_merge';
							}
						),
						new Custom(
							async function(variables)
							{
								let donePooling = false;
								variables.warnings = null;

								let postData = {
									'user_id' : 0,
									'action': 'deny',
								};

								while(!donePooling)
								{
									await new ApiMonizze()
										.postDataFromApi(
											self.urls.solve_same_name_users.replace('{reference}', self.order.reference),
											postData,
											function(data)
											{
												if( data === null )
												{
													return;
												}

												variables.number = data.exists;

												if(data.warnings && data.warnings.length > 0)
												{
													variables.warnings = data.warnings.map(htmlEncode).join('<br />');
												}

												donePooling = true;
											}
										);

									if( !donePooling )
									{
										await new Promise(resolve => setTimeout(resolve, 1000));
									}
								}
							}
						),
						new Call('error').if((variables) => variables.warnings),
					],
					summary_same_name: [
						new Custom(
							async function(variables)
							{
								let donePooling = false;
								variables.warnings = null;

								while(!donePooling)
								{
									await new ApiMonizze()
										.postDataFromApi(
											self.urls.summary_same_name_users.replace('{reference}', self.order.reference),
											{},
											function(data)
											{
												if( data === null )
												{
													return;
												}

												variables.number = data.exists;

												if(data.warnings && data.warnings.length > 0)
												{
													variables.warnings = data.warnings.map(htmlEncode).join('<br />');
												}

												donePooling = true;
											}
										);

									if( !donePooling )
									{
										await new Promise(resolve => setTimeout(resolve, 1000));
									}
								}
							}
						),
						new Call('error').if((variables) => variables.warnings),
					],
					//Check if the imported users have a temporary NISS that matches with existing users of the requesting customer
					resolve_temp_user : [
						new Call(
							function(variables)
							{
								if (variables.tempBenefsCheck.length > 0)
								{
									let item = variables.tempBenefsCheck.shift();

									variables.newNiss = item.new.niss;
									variables.newNissName = item.new.full_name;

									variables.tempUserId = item.old.user_id;
									variables.tempNiss = item.old.niss;
									variables.tempNissName = item.old.full_name;
								}
							}
						),
						new Message(trans.user_temporary_niss_found.intro),
						new Select(
							'confirm_action',
							Object.entries(trans.user_temporary_niss_found.options)
								.map(([key, value]) => new SelectOption(key, value.label))
						),
						new Message(variables => trans.user_temporary_niss_found.options[variables.confirm_action].response)
							.isFromUser(false),
						new Call('deny_user_merge').if((variables) => variables.confirm_action === 'deny'), // just act on deny
						new Call('resolve_temp_user').if((variables) => variables.tempBenefsCheck.length > 0),
						new Call('summary_temp_user_order').if((variables) => variables.tempBenefsCheck.length === 0),
					],
					deny_user_merge: [
						new Call(
							function(variables)
							{
								variables.names = variables.names.length > 0
									? variables.names + ', ' + variables.newNissName
									: variables.newNissName;
							}
						),
						new Custom(
							async function(variables)
							{
								let donePooling = false;
								variables.warnings = null;

								let postData = {
									'user_id' : variables.tempUserId
								};

								while(!donePooling)
								{
									await new ApiMonizze()
										.postDataFromApi(
											self.urls.deny_temp_benef.replace('{reference}', self.order.reference),
											postData,
											function(data)
											{
												if( data === null )
												{
													return;
												}

												variables.number = data.exists;

												if(data.warnings && data.warnings.length > 0)
												{
													variables.warnings = data.warnings.map(htmlEncode).join('<br />');
												}

												donePooling = true;
											}
										);

									if( !donePooling )
									{
										// We wait 1sec between retry
										await new Promise(resolve => setTimeout(resolve, 1000));
									}
								}
							}
						),
						new Call('error').if((variables) => variables.warnings),
					],
					summary_temp_user_order: [
						new Custom(
							async function(variables)
							{
								let donePooling = false;
								variables.warnings = null;

								while(!donePooling)
								{
									await new ApiMonizze()
										.postDataFromApi(
											self.urls.summary_temp_benef.replace('{reference}', self.order.reference),
											{},
											function(data)
											{
												if( data === null )
												{
													return;
												}

												variables.number = data.exists;

												if(data.warnings && data.warnings.length > 0)
												{
													variables.warnings = data.warnings.map(htmlEncode).join('<br />');
												}

												donePooling = true;
											}
										);

									if( !donePooling )
									{
										// We wait 1sec between retry
										await new Promise(resolve => setTimeout(resolve, 1000));
									}
								}
							}
						),
						new Call('error').if((variables) => variables.warnings && variables.warnings.length > 0),
					],
					summary: [
						new Call('resolve_temp_user').if((variables) => variables.tempBenefsCheck.length > 0),
						new Call('check_same_name').if((variables) => variables.sameNameBenef.length > 0),
						new Message(trans.summary.intro),
						new Message((variables) => variables.warnings, true).if((variables) => variables.warnings && variables.warnings.length > 0),
						new Message(trans.summary.new).if((variables) => variables.names.length > 0 && variables.currentFlow !== 'keep_imported_user' && variables.currentFlow !== 'keep_old_user'),
						new Message((variables) => trans.summary.ecoGiftWarning
							.replace(':quantity', variables.eco_gift_warning.quantity)
							.replaceAll(':facevalue', parseInt(variables.eco_gift_warning.facevalue) / 100)
							.replace(':total', (parseInt(variables.eco_gift_warning.facevalue) / 100) * variables.eco_gift_warning.quantity)
							, true).if((variables) => variables.eco_gift_warning.quantity > 1),
						new Message(trans.summary.ecvWarning, true).if(() => this.product === 'ecv'),
						new Select(
							'action',
							Object.entries(trans.summary.options)
								.filter(option => option[0] !== 'cancel')
								.map(([key, value]) => new SelectOption(key, value.label))
						),
						new Message((variables) => trans.summary.options[variables.action].response)
							.isFromUser(),
						new Call('confirmed').if((variables) => variables.action === 'correct'),
						new Custom(
							async function(variables)
							{
								new ApiMonizze()
									.postDataFromApi(
										self.urls.cancel.replace('{reference}', self.order.reference),
										{},
										function() {}
									)
									.catch(() => {});
							}
						).if((variables) => variables.action === 'retry'),
						new Custom(
							function()
							{
								self.$emit('cancel', self.order.reference);
							}
						).if((variables) => variables.action === 'retry'),
					],
					confirmed: [
						new Message(trans.confirmed.intro),
						new Call(
							function(variables)
							{
								self.preventUnload = false;
								variables.warnings = [];
							}
						),
						new Custom(
							async function(variables)
							{
								await new ApiMonizze()
									.postDataFromApi(
										self.urls.confirm.replace('{reference}', self.order.reference),
										{},
										function() {}
									);

								let donePooling = false;

								while(!donePooling)
								{
									await new ApiMonizze()
										.getDataFromApi(
											self.urls.status.replace('{reference}', self.order.reference),
											function(data)
											{
												if (data.warnings && data.warnings.length > 0)
												{
													variables.warnings = data.warnings.map(htmlEncode).join('<br />');
													donePooling = true;
													return;
												}

												if (!data.ready)
												{
													return;
												}

												donePooling = true;
											}
										);

									if (!donePooling)
									{
										// We wait 1sec between retry
										await new Promise(resolve => setTimeout(resolve, 1000));
									}
								}

								if (donePooling && variables.warnings.length <= 0)
								{
								  	self.$emit('processed', self.order.reference);
								}
							}
						),
						new Call('error').if((variables) => variables.warnings && variables.warnings.length > 0),
					],
					help: [
						new Message(trans.help.intro),
					],
				},
			}
		},
		methods: {
			closeChat()
			{
				this.$emit('close');
			}
		}
	}
</script>
